import React, {Component} from 'react'
import SwitchDeposit from './switchDeposit.jsx'
import PreviewHistory from '../Dashboard/previewHistory.jsx'
import { numberWithCommas } from '../../fiches';
import CommonFetch from '../../requests/commonFetch'

export default class Depository extends Component {
    constructor (props) {
        super(props)

        this.state = {
            data: {
                address: "",
                balanceDepository: "",
                balanceWalletCpt: "",
                balanceWalletEth: "",
                freeDepositEth: "",
                freeWithdrawCpt: "",
                depository:0,
                history:[
                    {
                        currency:"",
                        timestamp:0,
                        direction:"",
                        amount:0,
                        address:"",
                    }
                ]
            },
        }

        this.translation = JSON.parse(localStorage.translation)[localStorage.language];
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        CommonFetch({
            path: 'ui/depository/get_data',
            method: 'GET',
        }).then(data => {
            if (data.success) {
                let mainData = {
                    address: data.address,
                    balanceDepository: data.balance_depository,
                    balanceWalletCpt: data.balance_wallet_cpt,
                    balanceWalletEth: data.balance_wallet_eth,
                    freeDepositEth: data.fee_deposit_eth,
                    freeWithdrawCpt: data.fee_withdraw_cpt,
                    history: data.history,
                }
                this.setState({
                    data: mainData,
                })
            } else if (data.error === 'not_logged_in') {
                this.props.exitOverdueSession()
            }
        })
    }


    render() {
        return(
            <div className="depository">
                <div className="depository_header">
                    <h2>{this.translation['Depository']}<span> {numberWithCommas(this.state.data.balanceDepository)} cpt</span></h2>
                    <hr />
                </div>
                <div className="depository_left-panel">
                    <p><span>{this.translation['Depository is']}</span>{this.translation['Depository is internal Cryptaur']}</p>
                    <p>{this.translation['Payments in app']}</p>
                    <p>{this.translation['Transactions do not reflect']}</p>
                </div>
                <div className="depository_right-panel">
                    <SwitchDeposit exitOverdueSession={this.props.exitOverdueSession} data={this.state.data}/>
                    <PreviewHistory ecoAddress={this.state.data.address} history={this.state.data.history}/>
                </div>
            </div>
        )
    }
}
